// CitySelectionModal.js
import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import CreatableSelect from "react-select/creatable";
import { FiX } from "react-icons/fi";
import {
  getAllCities,
  getAllStates,
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const CitySelectionModal = ({ show, onHide, onSave, selectedCities }) => {
  const [localCities, setLocalCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  console.log(store, "profile");

  const authStore = useSelector((state) => state.auth);
  

  useEffect(() => {
    const profile = store?.profileItem?.data;
    if (profile) {
      setLocalCities({
        current: {
          state: {
            value: profile?.living_state ? profile?.living_state : "",
            label: profile?.living_state_info?.state_full_name || "",
            code: profile?.living_state || "",
          },
          city: {
            value: profile?.city || "",
            label: profile?.city || "",
          },
        },
        destination: {
          state: {
            value: profile?.work_state ? profile?.work_state : "",
            label: profile?.work_state_info?.state_full_name || "",
            code: profile?.work_state || "",
          },
          city: {
            value: profile?.work_city || "",
            label: profile?.work_city || "",
          },
        },
      });
    }
  }, [store?.profileItem]);

  useEffect(() => {
    dispatch(getAllStates());
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     getAllCities({
  //       search_state:
  //         localCities?.current?.state?.code ||
  //         localCities?.destination?.state?.code ||
  //         "",
  //     })
  //   );
  // }, [
  //   dispatch,
  //   localCities.current.state,
  //   localCities.destination.state,
  // ]);

  // Call API when current.state changes
  useEffect(() => {
    if (show && localCities?.current?.state?.code) {
      dispatch(
        getAllCities({
          role: authStore?.user?.nursing_role?.id,
          search_state: localCities.current.state.code,
        }),
      );
    }
  }, [
    dispatch,
    show,
    localCities?.current?.state?.code,
    authStore?.user?.nursing_role?.id,
  ]);

  // Call API when destination.state changes
  useEffect(() => {
    if (show && localCities?.destination?.state?.code) {
      dispatch(
        getAllCities({
          role: authStore?.user?.nursing_role?.id,
          search_state: localCities.destination.state.code,
        }),
      );
    }
  }, [
    dispatch,
    show,
    localCities?.destination?.state?.code,
    authStore?.user?.nursing_role?.id,
  ]);

  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store?.stateItems?.data?.states?.map((state) => ({
        value: state.id,
        label: state.state_full_name,
        code: state.state,
      }));
      setStateOptions(options);
    }
    if (store?.cityItems?.data?.cities) {
      const options = store.cityItems.data.cities.map((cityObj, index) => ({
        value: cityObj.city,
        label: cityObj.city,
      }));
      setCityOptions(options);
    }
  }, [store?.stateItems, store?.cityItems]);

  // Cities dataset by state
  const citiesByState = {
    AK: [
      { value: "AH", label: "Anchorage" },
      { value: "FA", label: "Fairbanks" },
      { value: "HO", label: "Homer" },
      { value: "JU", label: "Juneau" },
      { value: "KE", label: "Kenai" },
    ],
    AL: [
      { value: "AI", label: "Anniston" },
      { value: "AU", label: "Auburn" },
      { value: "BH", label: "Birmingham" },
      { value: "DH", label: "Daphne" },
      { value: "DE", label: "Decatur" },
    ],
    AR: [
      { value: "BN", label: "Benton" },
      { value: "BV", label: "Bentonville" },
      { value: "CA", label: "Conway" },
      { value: "FA", label: "Fayetteville" },
      { value: "FS", label: "Fort Smith" },
    ],
    AZ: [
      { value: "AV", label: "Avondale" },
      { value: "BK", label: "Buckeye" },
      { value: "CH", label: "Chandler" },
      { value: "DO", label: "Douglas" },
      { value: "FL", label: "Flagstaff" },
    ],

    CA: [
      { value: "AL", label: "Alameda" },
      { value: "AB", label: "Alhambra" },
      { value: "AH", label: "Anaheim" },
      { value: "AT", label: "Antioch" },
      { value: "AV", label: "Apple Valley" },
    ],
  };

  // Save
  const handleSave = () => {
    if (
      localCities.current.state &&
      localCities.current.city &&
      localCities.destination.state &&
      localCities.destination.city
    ) {
      onSave(localCities);
      onHide();
    }
  };

  const onSubmit = () => {
    if (store?.profileItem?.data?.full_name) {
      const payload = {
        name: store?.profileItem?.data?.full_name || "",
        city: localCities?.current?.city?.value,
        // living_state: localCities.current?.state?.label?.toString(),
        living_state: localCities.current?.state?.code?.toString(),
        // work_state: localCities?.destination?.state?.label?.toString(),
        work_state: localCities?.destination?.state?.code?.toString(),
        work_city: localCities?.destination?.city?.value,
      };

      dispatch(updateProfile(payload));
    }
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
      // dispatch(getViewProfile());
    }
  }, [store?.actionFlag, onHide]);

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_YOUR_CITY_AND_STATE", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_YOUR_CITY_AND_STATE" }));
    };
  }, [show, dispatch]);
  
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select Your Cities</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <h6 className="main-label">Choose Your Home City.</h6>
        <Row>
          <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">State</Form.Label>
              <Select
                options={stateOptions}
                value={localCities?.current?.state}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    current: { state: selected, city: null },
                  }))
                }
                menuPosition="fixed"
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select State"
                isClearable
              />
            </Form.Group>
          </Col>
          {/* <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">City</Form.Label>
              <Select
                options={cityOptions}
                value={localCities.current.city}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    current: { ...prev.current, city: selected },
                  }))
                }
                menuPosition="fixed"
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                placeholder="Select City"
                isDisabled={!localCities.current.state}
                isClearable
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </Form.Group>
          </Col> */}
          <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">City</Form.Label>
              <CreatableSelect
                options={cityOptions}
                value={localCities.current.city}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    current: { ...prev.current, city: selected },
                  }))
                }
                onCreateOption={(inputValue) => {
                  // Trim and normalize input
                  const formattedValue = inputValue.trim();

                  if (!formattedValue) return;

                  // Check duplicate (case-insensitive)
                  const isDuplicate = cityOptions.some(
                    (option) =>
                      option.value.toLowerCase() ===
                      formattedValue.toLowerCase(),
                  );

                  if (isDuplicate) {
                    alert("City already exists!");
                    return;
                  }

                  // Create new option
                  const newOption = {
                    label: formattedValue,
                    value: formattedValue,
                  };

                  // Optional: add to options list
                  setCityOptions((prev) => [...prev, newOption]);

                  // Set as selected city
                  setLocalCities((prev) => ({
                    ...prev,
                    current: { ...prev.current, city: newOption },
                  }));
                }}
                menuPosition="fixed"
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                formatCreateLabel={(inputValue) => `City "${inputValue}"`}
                placeholder="Select or Type City"
                isDisabled={!localCities.current.state}
                isClearable
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </Form.Group>
          </Col>
        </Row>

        <h6 className="main-label">Select Destination City.</h6>
        <Row>
          <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">State</Form.Label>
              <Select
                options={stateOptions}
                value={localCities.destination.state}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    destination: { state: selected, city: null },
                  }))
                }
                menuPosition="fixed"
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select State"
                isClearable
              />
            </Form.Group>
          </Col>
          {/* <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">City</Form.Label>
              <Select
                options={cityOptions}
                value={localCities.destination.city}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    destination: { ...prev.destination, city: selected },
                  }))
                }
                menuPosition="fixed"
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                placeholder="Select City"
                isClearable
                className="react-select-container"
                classNamePrefix="react-select"
                isDisabled={!localCities.destination.state}
              />
            </Form.Group>
          </Col> */}
          <Col md={6}>
            <Form.Group className="form-group">
              <Form.Label className="col-label">City</Form.Label>

              <CreatableSelect
                options={cityOptions}
                value={localCities.destination.city}
                onChange={(selected) =>
                  setLocalCities((prev) => ({
                    ...prev,
                    destination: { ...prev.destination, city: selected },
                  }))
                }
                onCreateOption={(inputValue) => {
                  const formattedValue = inputValue.trim();
                  if (!formattedValue) return;

                  const isDuplicate = cityOptions.some(
                    (option) =>
                      option.value.toLowerCase() ===
                      formattedValue.toLowerCase(),
                  );

                  if (isDuplicate) {
                    alert("City already exists!");
                    return;
                  }

                  const newOption = {
                    label: formattedValue,
                    value: formattedValue,
                  };

                  setCityOptions((prev) => [...prev, newOption]);

                  setLocalCities((prev) => ({
                    ...prev,
                    destination: { ...prev.destination, city: newOption },
                  }));
                }}
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                formatCreateLabel={(inputValue) => `City "${inputValue}"`}
                placeholder="Select or Type City"
                isClearable
                className="react-select-container"
                classNamePrefix="react-select"
                isDisabled={!localCities.destination.state}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={
              store?.isLoading ||
              !localCities.current.state ||
              !localCities.current.city ||
              !localCities.destination.state ||
              !localCities.destination.city
            }
          >
            {store?.isLoading ? "Saving..." : "Save"} <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CitySelectionModal;
